(function () {
  const COLECCION_GENERO = {
    'perfumes-de-hombre': 'hombre',
    'perfumes-de-mujer': 'mujer',
    'perfumes-nicho': 'nicho'
  };

  const ICONO_GENERO = {
    'hombre': '♂',
    'mujer': '♀',
    'nicho': '💎'
  };

  async function cargarPerfumes(colecciones) {
    const handles = colecciones.split(',').map(c => c.trim()).filter(Boolean);
    let todos = [];

    for (const handle of handles) {
      const genero = COLECCION_GENERO[handle] || 'hombre';
      let pagina = 1;
      let seguir = true;

      while (seguir) {
        try {
          const res = await fetch(`/collections/${handle}/products.json?limit=250&page=${pagina}`);
          const data = await res.json();
          const prods = data.products || [];
          if (prods.length === 0) { seguir = false; break; }

          for (const p of prods) {
            const existe = todos.find(t => t.titulo === p.title);
            if (existe) {
              if (genero === 'nicho') existe.generos.push('nicho');
            } else {
              todos.push({
                id: p.variants[0].id,
                titulo: p.title,
                generos: [genero]
              });
            }
          }

          if (prods.length < 250) seguir = false;
          else pagina++;
        } catch (e) {
          seguir = false;
        }
      }
    }

    todos.sort((a, b) => a.titulo.localeCompare(b.titulo));
    return todos;
  }

  function getIconos(generos) {
    const iconos = [];
    if (generos.includes('hombre')) iconos.push('♂');
    if (generos.includes('mujer')) iconos.push('♀');
    if (generos.includes('nicho')) iconos.push('💎');
    return iconos.join('');
  }

  function iniciarMuestraSelector(wrapper) {
    const slots = parseInt(wrapper.dataset.slots) || 3;
    const colecciones = wrapper.dataset.colecciones || 'perfumes-de-hombre,perfumes-de-mujer,perfumes-nicho';

    const lista = wrapper.querySelector('.muestra-selector__lista');
    const chips = wrapper.querySelector('.muestra-selector__chips');
    const hiddenInputs = wrapper.querySelector('.muestra-selector__hidden-inputs');
    const buscador = wrapper.querySelector('.muestra-selector__buscador');
    const progresoFill = wrapper.querySelector('.muestra-selector__progreso-fill');
    const progresoTexto = wrapper.querySelector('.muestra-selector__progreso-texto');
    const borrarTodo = wrapper.querySelector('.muestra-selector__borrar-todo');
    const tabs = wrapper.querySelectorAll('.muestra-selector__tab');
    const btnAleatorio = wrapper.querySelector('[data-accion="aleatorio"]');
    const btnNosotros = wrapper.querySelector('[data-accion="nosotros"]');

    let todosLosPerfumes = [];
    let seleccionados = [];
    let tabActivo = 'todos';

    lista.innerHTML = '<li class="muestra-selector__cargando">Cargando perfumes...</li>';

    cargarPerfumes(colecciones).then(perfumes => {
      todosLosPerfumes = perfumes;
      renderLista();
    });

    function actualizarProgreso() {
      const pct = slots > 0 ? (seleccionados.length / slots) * 100 : 0;
      progresoFill.style.width = pct + '%';
      progresoTexto.textContent = `${seleccionados.length} / ${slots} seleccionadas`;
    }

    function renderChips() {
      chips.innerHTML = '';
      if (seleccionados.length === 0) {
        chips.innerHTML = '<span class="muestra-selector__chips-vacio">Ninguna seleccionada aún</span>';
        return;
      }
      seleccionados.forEach((p, i) => {
        const chip = document.createElement('div');
        chip.className = 'muestra-selector__chip';
        chip.innerHTML = `<span>${getIconos(p.generos)} ${p.titulo}</span><button type="button" class="muestra-selector__chip-remove" data-index="${i}">✕</button>`;
        chip.querySelector('.muestra-selector__chip-remove').addEventListener('click', () => {
          seleccionados.splice(i, 1);
          actualizarHiddenInputs();
          renderChips();
          renderLista();
          actualizarProgreso();
        });
        chips.appendChild(chip);
      });
    }

    function actualizarHiddenInputs() {
      hiddenInputs.innerHTML = '';
      seleccionados.forEach((p, i) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = `properties[Muestra ${i + 1}]`;
        input.value = p.titulo;
        hiddenInputs.appendChild(input);
      });
    }

    function renderLista() {
      lista.innerHTML = '';
      const filtroTexto = buscador.value.toLowerCase();

      let filtrados = todosLosPerfumes.filter(p => {
        const coincideTexto = p.titulo.toLowerCase().includes(filtroTexto);
        const coincideTab = tabActivo === 'todos' || p.generos.includes(tabActivo);
        return coincideTexto && coincideTab;
      });

      if (filtrados.length === 0) {
        lista.innerHTML = '<li class="muestra-selector__sin-resultados">No se encontraron perfumes</li>';
        return;
      }

      filtrados.forEach(p => {
        const yaSeleccionado = seleccionados.find(s => s.id === p.id);
        const li = document.createElement('li');
        li.className = 'muestra-selector__item' + (yaSeleccionado ? ' seleccionado' : '');
        li.innerHTML = `
          <div class="muestra-selector__item-info">
            <span class="muestra-selector__item-icono">${getIconos(p.generos)}</span>
            <span class="muestra-selector__item-nombre">${p.titulo}</span>
          </div>
          <span class="muestra-selector__item-add">${yaSeleccionado ? '✓' : '+'}</span>
        `;

        if (!yaSeleccionado) {
          li.addEventListener('click', () => {
            if (seleccionados.length >= slots) {
              alert(`Solo puedes elegir ${slots} muestras`);
              return;
            }
            seleccionados.push(p);
            actualizarHiddenInputs();
            renderChips();
            renderLista();
            actualizarProgreso();
          });
        }

        lista.appendChild(li);
      });
    }

    buscador.addEventListener('input', renderLista);

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        tabs.forEach(t => t.classList.remove('active'));
        tab.classList.add('active');
        tabActivo = tab.dataset.tab;
        renderLista();
      });
    });

    borrarTodo.addEventListener('click', () => {
      seleccionados = [];
      actualizarHiddenInputs();
      renderChips();
      renderLista();
      actualizarProgreso();
    });

    btnAleatorio.addEventListener('click', () => {
      seleccionados = [];
      const disponibles = [...todosLosPerfumes];
      while (seleccionados.length < slots && disponibles.length > 0) {
        const idx = Math.floor(Math.random() * disponibles.length);
        seleccionados.push(disponibles.splice(idx, 1)[0]);
      }
      actualizarHiddenInputs();
      renderChips();
      renderLista();
      actualizarProgreso();
    });

    btnNosotros.addEventListener('click', () => {
      seleccionados = [];
      hiddenInputs.innerHTML = '';
      chips.innerHTML = '';

      for (let i = 0; i < slots; i++) {
        const inp = document.createElement('input');
        inp.type = 'hidden';
        inp.name = `properties[Muestra ${i + 1}]`;
        inp.value = 'Sorpresa';
        hiddenInputs.appendChild(inp);

        const chip = document.createElement('div');
        chip.className = 'muestra-selector__chip';
        chip.innerHTML = '<span>🎁 Sorpresa</span>';
        chips.appendChild(chip);
      }

      progresoFill.style.width = '100%';
      progresoTexto.textContent = `${slots} / ${slots} seleccionadas`;
    });

    const form = wrapper.closest('form');
    if (form) {
      form.addEventListener('submit', (e) => {
        const inp = hiddenInputs.querySelector('input');
        if (!inp) {
          e.preventDefault();
          e.stopPropagation();
          alert(`Por favor selecciona ${slots} muestras`);
          wrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, true);
    }

    actualizarProgreso();
    renderChips();
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.muestra-selector').forEach(iniciarMuestraSelector);
  });
})();
